import React from "react";
import SimpleBar from "simplebar-react";
import { useSelector } from "react-redux";
import Icon from "@/components/ui/Icon";
import ProfileCircle from "@/pages/chat/ProfileCircle";

const socials = [
  {
    name: "facebook",
    icon: "bi:facebook",
    link: "#",
  },
  {
    name: "twitter",
    link: "#",
    icon: "bi:twitter",
  },
  {
    name: "instagram",
    link: "#",
    icon: "bi:instagram",
  },
];

const Info = () => {
  const { activechat, user } = useSelector((state) => state.chat);
  let browserVer = user?.device?.browser_ver;
  let osVer = user?.device?.os_ver;
  browserVer = browserVer ? browserVer.split(".", 2).join(".") : "";
  osVer = osVer ? osVer.split(".", 2).join(".") : "";

  return (
    <SimpleBar className="h-full p-6">
      <h4 className="text-xl text-slate-900 font-medium mb-8">About</h4>
      <div className="h-[100px] w-[100px] rounded-full mx-auto mb-4">
        <ProfileCircle contact={user} />
      </div>
      <div className="text-center">
        <h5 className="text-base text-slate-600 dark:text-slate-300 font-medium mb-1">
          {user.fullName}
        </h5>
        <h6 className="text-xs text-slate-600 dark:text-slate-300 font-normal">
          {user.role}
        </h6>
      </div>
      {user.visitor_data &&
        <ul className="list-item mt-5 space-y-4 border-b border-slate-100 dark:border-slate-700 pb-5 -mx-6 px-6">
          {Object.keys(user.visitor_data).map((title, i) => {
            return (
              <li key={i} className="flex justify-between text-sm text-slate-600 dark:text-slate-300 leading-[1]">
                <div className="flex space-x-2 items-start rtl:space-x-reverse">
                  <span>{title}</span>
                </div>
                <div className="font-medium">{user.visitor_data[title]}</div>
              </li>
            );
          })}
        </ul>
      }
      <ul className="list-item mt-5 space-y-4 border-b border-slate-100 dark:border-slate-700 pb-5 -mx-6 px-6">
        <li className="flex justify-between text-sm text-slate-600 dark:text-slate-300 leading-[1]">
          <div className="flex space-x-2 items-start rtl:space-x-reverse">
            <Icon
              icon="heroicons-outline:location-marker"
              className="text-base"
            />
            <span>Location</span>
          </div>
          <div className="font-medium">{user.geo.country}</div>
        </li>
        <li className="flex justify-between text-sm text-slate-600 dark:text-slate-300 leading-[1]">
          <div className="flex space-x-2 items-start rtl:space-x-reverse">
            <Icon
              icon="heroicons-outline:location-marker"
              className="text-base"
            />
            <span>IP</span>
          </div>
          <div className="font-medium">{user.geo.ip}</div>
        </li>
        <li className="flex justify-between text-sm text-slate-600 dark:text-slate-300 leading-[1]">
          <div className="flex space-x-2 items-start rtl:space-x-reverse">
            <Icon
              icon="heroicons-outline:globe-alt"
              className="text-base"
            />
            <span>Browser</span>
          </div>
          <div className="font-medium">{user.device.browser_name} {browserVer}</div>
        </li>
        <li className="flex justify-between text-sm text-slate-600 dark:text-slate-300 leading-[1]">
          <div className="flex space-x-2 items-start rtl:space-x-reverse">
            <Icon
              icon="heroicons-outline:desktop-computer"
              className="text-base"
            />
            <span>OS</span>
          </div>
          <div className="font-medium">{user.device.os_name} {osVer}</div>
        </li>
      </ul>
      {/*<ul className="list-item space-y-3 border-b border-slate-100 dark:border-slate-700 pb-5 -mx-6 px-6 mt-5">*/}
      {/*  {socials?.map((slink, sindex) => (*/}
      {/*    <li*/}
      {/*      key={sindex}*/}
      {/*      className="text-sm text-slate-600 dark:text-slate-300 leading-[1]"*/}
      {/*    >*/}
      {/*      <button className="flex space-x-2 rtl:space-x-reverse">*/}
      {/*        <Icon icon={slink.icon} className="text-base" />*/}
      {/*        <span className="capitalize font-normal text-slate-600 dark:text-slate-300">*/}
      {/*          {slink.name}*/}
      {/*        </span>*/}
      {/*      </button>*/}
      {/*    </li>*/}
      {/*  ))}*/}
      {/*</ul>*/}
      {/*<h4 className="py-4 text-sm text-secondary-500 dark:text-slate-300 font-normal">*/}
      {/*  Shared documents*/}
      {/*</h4>*/}
    </SimpleBar>
  );
};

export default Info;
